import React from 'react';
import PropTypes from 'prop-types';
import { Box, Fade, Typography } from '@mui/material';

const CategoryRibbon = React.memo(({ categories }) => {

    
    return (
      <Box sx={{
        position: 'absolute',
        top: 16,
        right: 16,
        display: 'flex',
        gap: 1,
        zIndex: 1,
        flexWrap: 'wrap',
        justifyContent: 'flex-end',
        transform: 'translateY(-50%)'
      }}>
        {categories?.split(',').map((category, index) => (
          <Fade in key={`${index}-${category}`}>
            <Typography
              component="span"
              sx={{
                px: 2,
                py: 0.5,
                bgcolor: 'secondary.main',
                color: 'white',
                borderRadius: 1,
                boxShadow: 3,
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                letterSpacing: 1,
                transition: 'all 0.3s ease',
                '&:hover': { transform: 'scale(1.05)' }
              }}
            >
              {category.trim()}
            </Typography>
          </Fade>
        ))}
      </Box>
    );
  });

CategoryRibbon.propTypes = {
  categories: PropTypes.string
};

export default CategoryRibbon;
